interface Config {
  mode: string
  restApiUrl: string
  affiliateUrl: string
  contactUrl: string
  previewUrl: string
  firestoreBucketUrl: string
  imageServer: string
  externalScriptFallbackURL: string
  levelUpEnabledLocations: string[]
}
const imageServerWhitelist = [
  'images.unsplash.com',
  'cdn.pixabay.com',
  'storage.googleapis.com',
  'firebasestorage.googleapis.com',
  'pixabay.com',
  'assets-staging.cdn.msgsndr.com',
  'staging.cdn.msgsndr.com',
  'staging.filesafe.space',
  'default.staging.filesafe.space',
  'assets.cdn.msgsndr.com',
  'cdn.msgsndr.com',
  'cdn.filesafe.space',
  'assets.cdn.filesafe.space',
  'img.youtube.com',
  'i.vimeocdn.com',
  'embed-ssl.wistia.com',
  'widgets.leadconnectorhq.com',
]

const config: { [key: string]: Config } = {
  development: {
    mode: 'dev',
    restApiUrl: 'https://staging.backend.leadconnectorhq.com',
    affiliateUrl: 'https://staging.backend.leadconnectorhq.com',
    contactUrl: 'https://staging.backend.leadconnectorhq.com/contacts',
    previewUrl: 'https://staging.gohighlevel.com',
    firestoreBucketUrl: 'https://storage.googleapis.com',
    imageServer: 'https://staging.images.leadconnectorhq.com',
    externalScriptFallbackURL:
      'https://storage.googleapis.com/builder-preview/form_embed/staging/am.js',
    levelUpEnabledLocations: ['iVrVJ2uoXNF0wzcBzgl5'],
  },
  staging: {
    mode: 'staging',
    restApiUrl: 'https://staging.backend.leadconnectorhq.com',
    affiliateUrl: 'https://staging.backend.leadconnectorhq.com',
    contactUrl: 'https://staging.backend.leadconnectorhq.com/contacts',
    previewUrl:
      'https://affiliate-builder-dot-funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    firestoreBucketUrl: 'https://storage.googleapis.com',
    imageServer: 'https://staging.images.leadconnectorhq.com',
    externalScriptFallbackURL:
      'https://storage.googleapis.com/builder-preview/form_embed/staging/am.js',
    levelUpEnabledLocations: ['iVrVJ2uoXNF0wzcBzgl5'],
  },
  interop: {
    mode: 'interop',
    restApiUrl: 'https://interop.backend.leadconnectorhq.com',
    affiliateUrl: 'https://interop.backend.leadconnectorhq.com',
    contactUrl: 'https://interop.backend.leadconnectorhq.com/contacts',
    previewUrl: 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com',
    firestoreBucketUrl: 'https://storage.googleapis.com',
    imageServer: 'https://staging.images.leadconnectorhq.com',
    externalScriptFallbackURL:
      'https://storage.googleapis.com/builder-preview/form_embed/staging/am.js',
    levelUpEnabledLocations: ['iVrVJ2uoXNF0wzcBzgl5'],
  },
  production: {
    mode: 'production',
    restApiUrl: 'https://backend.leadconnectorhq.com',
    affiliateUrl: 'https://backend.leadconnectorhq.com',
    contactUrl: 'https://backend.leadconnectorhq.com/contacts',
    previewUrl: 'https://app.leadconnectorhq.com',
    firestoreBucketUrl: 'https://storage.googleapis.com',
    imageServer: 'https://images.leadconnectorhq.com',
    externalScriptFallbackURL:
      'https://stcdn.leadconnectorhq.com/form_embed/prod/am.js',
    levelUpEnabledLocations: [
      'dyKbBe6XZJBFUoxeQyQT',
      'PckM5393o8V8VUL7PYcb',
      'hk9aJw1NxnORXlvWt0Ch',
    ],
  },
}

const override = false

const overrideConfig = {}
const envConfig = config[process.env.NODE_ENV || 'production']

export default override
  ? { ...envConfig, ...overrideConfig, imageServerWhitelist }
  : { ...envConfig, imageServerWhitelist }
